import { useContext } from 'react'
import { USER_CONTEXT } from '../context/ContextProvider'

const useCreateTask = () => {
  let { setData } = useContext(USER_CONTEXT)
  let createTask = (task, edit = false) => {
    try {
      if (edit) {
        setData({
          type: 'EDIT_TASK',
          payload: {
            ...task,
          },
        })
      } else {
        setData({
          type: 'ADD_TASK',
          payload: {
            ...task,
          },
        })
      }
    } catch (error) {
      alert('Enter form data correctly!')
    }
  }
  return createTask
}

export default useCreateTask
